var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white rounded-sm"},[(_vm.page && _vm.contentReady)?[_c('h1',[_vm._v(" "+_vm._s(_vm.page.title)+" ")]),_c('p',{staticClass:"page__content",domProps:{"innerHTML":_vm._s(_vm.page.content)}})]:[_c('Loader')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }